export const environment = {
  production: false,
  envName: 'prod',
  apiUrl: 'https://api.nowgrocery.com/api/',
  imageUrl: 'https://cdn2.nowgrocery.com/Uploads/',
  referralUrl: 'https://www.nowgrocery.com/',
  paymentURL: 'https://payment.nowgrocery.com/pay.php',
  samsungCategoryId: "307",
  phonepeReturnUrl: "https://www.nowgrocery.com/orderdetail/"

};



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/environments/environment.ts